import { doSchemaCreate } from "../../actions/thunks/schemaThunks";
import { getAccessToken } from "../storage/accessTokenStorage";

const dispatchSchemaCreate = (component, endpoint, payload, callback) => {
  const creationEndpoint = endpoint || component.props.submitEndpoint;
  const accessToken = component.props.accessToken || getAccessToken();
  component.props.dispatch(
    doSchemaCreate({
      accessToken,
      endpoint: creationEndpoint,
      payload,
      navigate: component.props.navigate,
      callback,
    })
  );
};

export default dispatchSchemaCreate;
